<template>
  <div id="app">
    <Header id="header" />
    <!--div class="stickyTop top-border"></div-->
    <ThemePicker class="stickyTop" />

    <router-view id="router"/>
    <!--footer id="footer">
      Ekokammaren är skapad av Interaktiva rum
    </footer-->
  </div>
</template>

<script>

//import Vue from 'vue'
import Header from '@/views/Header.vue'
import ThemePicker from '@/components/ThemePicker.vue'

export default {
  components: {
    Header,
    ThemePicker
  },
  computed: {
    fb: function () {
      return this.$route.query.fbclid
    }
  },
  watch: {
    fb: function () {
      this.removeFbQuery();
    }
  },
  methods: {
    setScrollListener: function () {
      let self = this;
      this.$el.addEventListener("scroll", function(e){
        self.$eventBus.$emit('feed-scroll',e)
      })
    },
    removeFbQuery: function () {
      if(this.$route.query.fbclid) {
        let query = Object.assign({}, this.$route.query);
        query.fbclid = undefined;
        this.$router.push({path: this.$route.path, query: query})
      }
    }
  },
  mounted: function () {
    this.setScrollListener();
    this.$store.dispatch('init')
  }
}
</script>

<style lang="scss">

@import './assets/style/layout.css';
@import './assets/style/text.css';
@import './assets/style/form.css';
@import './assets/style/elements.css';

.top-border{
  border-top: 5px solid var(--color);
  z-index: 2;
}

</style>
